<template>
    <main id="uvod" role="main">
        <loader></loader>
        <div id="panel-top" class="ve-panel">
            <!--         :style="{backgroundSize: zoomRatio}">-->
            <navbar-top-light ></navbar-top-light>
            <div class="container-fluid">
                <div class="headline text-white">
                    <h1 style="border-bottom: 3px solid white">Čerstvě utrženo<br/> Haná</h1>

                    <p>Správa vlastního majetku – podílů v dceřiných společnostech<br/>
                        AGRO Haná a.s. IČO: 02849895 <br/> a
                        Farma Kopeček s.r.o., IČO: 29232996, <br/>
                        které vlastní skleníky <a target="_blank" style="color:white;" href="https://farmasmrzice.cz">Farma
                            Smržice </a>
                        a <a style="color:white;" href="https://farmakopecek.cz/"  target="_blank">Farma Kopeček</a></p>
                    <!--  <a href="http://www.cerstveutrzeno.cz" target="_blank">
                          <img src="/images/cerstveutrzeno_new.png" id="cersve-utrzeno-logo"></a> -->
                </div>

                <!--                <panel-eco-park/>-->
            </div>
        </div>
        <a class="anchor invisible"
           id="kontakt"></a>

        <div class="container-fluid">
            <div class="container">
                <div class="ve-panel">
                    <div class="row kont">
                        <div class="col-md-6 mb-5 ">
                            <h1>Kontakt</h1>
                            <p>
                                <b>Název</b>: Čerstvě utrženo Haná a.s.<br>
                                <b>IČO</b>: 09431535<br/>
                                <b>Spisová značka</b>: B 8431/KSBR Krajský soud v Brně<br/>
                                <b>Sídlo společnosti</b>: U hřiště 320, 798 17 Smržice<br/>
                                <b>Základní kapitál společnosti činí 2.000.000,- Kč a byl plně splacen.</b><br/>
                            </p>
                            <hr>
                            <div>
                                <div>
                                    <h2 class="mt-3 d-inline-block">Štěpán Rybář</h2>
                                    <p class="notop">Kontaktní osoba</p>
                                    <p><i class="fa fas fa-envelope"></i> <a href="mailto:stepan.rybar@ecofinance.cz">stepan.rybar@ecofinance.cz</a></p>
                                    <p><i class="fa fas fa-phone"></i> +420 582 331 255</p>
                                    <hr>
                                </div>
                            </div>

                        </div>

                        <div class="col-md-6">
                            <iframe
                                style="border-width: 0px; border-style: initial; border-color: currentcolor; float: right; border-radius: 7px"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d770.1639990812702!2d17.106801633932143!3d49.5125979102942!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47125a742d1c12b3%3A0xf9e208874b8cc7fa!2zVSBIxZlpxaF0xJsgMzIwLCA3OTggMTcgU21yxb5pY2U!5e0!3m2!1scs!2scz!4v1661755942443!5m2!1scs!2scz"
                                wframeborder="0"
                                width="100%"
                                height="400" loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-sm-4">

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">

                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- FOOTER -->
        <footer class="d-flex  px-3">
            <div class="col-4">
                <p>&copy; {{ year }} <b>Čerstvě utrženo Haná a.s.</b></p>
            </div>
            <div class="col-4 text-center">
                <a class="nav-link nav-item" href="/login">Přihlášení</a>
            </div>
            <div class="col-4 text-end" >
                <softici-badge></softici-badge>
            </div>
        </footer>
    </main>
</template>

<script>
import PanelEcoPark from "./PanelEcoPark";
import NavbarTopLight from "./NavbarTopLight";
import SofticiBadge from "./SofticiBadge";

export default {
    name: "panel-home",
    components: {NavbarTopLight, PanelEcoPark, SofticiBadge},
    data: () => {
        return {
            scrollY: 0,
        }
    },

    mounted() {
        // Listen to page scroll event.
        window.addEventListener('scroll', this.handleScroll);
    },

    computed: {
        year(){
            return new Date().getFullYear()
        }
        // zoomRatio: function () {
        //     // 825 ... 120
        //     // 1 ... 0,14545
        //     // 0 .. 100
        //
        //     let num = 140 - (this.scrollY * 0.04);
        //     return num + '%';
        // }
    },

    methods: {
        // Save scroll change
        handleScroll() {
            this.scrollY = window.scrollY;
        }
    },
}
</script>
